import React, { createContext, useCallback, useContext, useEffect, useState } from "react";
import auth from "../core/auth";

/**
 * React arayüzü ile IAuthAdapter köprüsü. Component'ler aşağıdaki hook'u
 * kullanmalı:
 *
 *   const { user, isAuthenticated, signIn, signOut } = useAuth();
 *
 * Adapter swap edilebilir (Mock ↔ Jwt) — sadece env değişir, hiçbir
 * component dokunulmaz (DIP prensibi).
 */

const AuthContext = createContext(null);

export const useAuth = () => {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be used within <AuthProvider>");
  return ctx;
};

const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [isAuthenticated, setIsAuthenticated] = useState(auth.isAuthenticated());
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const u = await auth.getUser();
        if (!cancelled) {
          setUser(u);
          setIsAuthenticated(auth.isAuthenticated());
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  const signIn = useCallback(async (email, password) => {
    const u = await auth.signIn(email, password);
    setUser(u);
    setIsAuthenticated(true);
    return u;
  }, []);

  const signOut = useCallback(async () => {
    await auth.signOut();
    setUser(null);
    setIsAuthenticated(false);
  }, []);

  const value = { user, isAuthenticated, loading, signIn, signOut };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export default AuthProvider;
